import { MaintenancePage as MaintenancePageView } from '@nps.today/component-library';
import { useRemoteConfig } from 'utils/firebase/useRemoteConfig';
import {
  DownTimeReasonDesciptionConfig,
  DownTimeReasonTitleConfig,
  ExpectedBackAtConfig
} from 'utils/firebase/remoteConfigKey';

export const MaintenancePage = () => {
  const { getRemoteConfigValue } = useRemoteConfig();
  const title = getRemoteConfigValue(DownTimeReasonTitleConfig);
  const description = getRemoteConfigValue(DownTimeReasonDesciptionConfig);
  const expectedBackAt = getRemoteConfigValue(ExpectedBackAtConfig);
  return (
    <MaintenancePageView title={title} description={description} expectedBackAt={expectedBackAt} />
  );
};
